import styled from 'styled-components';

export const UserAvatarContainer = styled.span`
    border-radius: 50%;
    display: flex;
    overflow: visible;
    position: relative;
`;
